/**
 * =============================================================================
 * product-tile.js
 * =============================================================================
 * Manage state of a single product tile.
 * 
 * TODO: Other Stencil product tile stuff needs to get migrated here.
 * =============================================================================
 */

class ProductTile {
   container;
 
   swiperMedia; // Injected in a pre init callback from tile-product.liquid

   constructor(container) {
    this.container = container;

    this.container.addEventListener('mouseover', this.onMouseover.bind(this));
    this.container.addEventListener('mouseout', this.onMouseout.bind(this));

    let swatches = this.container.querySelectorAll(".variant-swatch");
    swatches.forEach(element => {
      element.addEventListener("mouseover", this.onMouseoverSwatch.bind(this));
    });
  }

  onMouseover(e) {
    this.swiperMedia.slideTo(1);
    this.container.querySelector(".variant-colours .messaging")?.classList.add("d-none");
    this.container.querySelector(".variant-colours .swatches")?.classList.remove("d-none");
  }
  onMouseout(e) {
    this.swiperMedia.slideTo(0);
    this.container.querySelector(".variant-colours .messaging")?.classList.remove("d-none");
    this.container.querySelector(".variant-colours .swatches")?.classList.add("d-none");
  }

  onMouseoverSwatch(e) {
    let swatchOptionValue = e.target.dataset.value
    // Update Swiper current slide
    const matchingSlide = this.container.querySelector(`[data-value*='${swatchOptionValue}']:not(.swiper-slide-duplicate)`);
    if(matchingSlide){
      const slideIndex = matchingSlide.dataset.index;
      if(slideIndex){
        // For some reason this only works in a timeout...? because Mouseover is also triggered!
        setTimeout(() => {
          this.swiperMedia.slideTo(parseInt(slideIndex));
        }, 50);
      }
    }
  }
}
 
export default ProductTile;